import React from 'react';
import './Registro.scss';

class Registro extends React.Component {
  render () {
      return (
      <div className="registro__diario__container">
        <h1 className="registro__diario__title">Registro</h1>
        <table className="registro__diario__table">
          <thead>
            <tr className="registro__diario__table__header">
              <th className="registro__diario__table__header__item">DÍA/HORA</th>
              <th className="registro__diario__table__header__item">LOCALIZACIÓN</th>
              <th className="registro__diario__table__header__item">ARTÍCULO</th>
              <th className="registro__diario__table__header__item">DESCRIPCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr className="registro__diario__table__body">
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</td>
            </tr>
            <tr className="registro__diario__table__body">
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</td>
            </tr>
            <tr className="registro__diario__table__body">
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</td>
            </tr>
            <tr className="registro__diario__table__body">
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</td>
            </tr>
            <tr className="registro__diario__table__body">
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem Ipsum</td>
              <td className="registro__diario__table__body__item">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default Registro;
